<script>
	import { fade } from 'svelte/transition';
    
    let message = false
    
    const hide = () => {
        message = false
    }

    export const display = (msg) => {
        message = msg || 'Une erreur est survenue'
        setTimeout(hide, 4000)
    }
    </script>
    
    {#if message}
    <span transition:fade>
        {message}
    </span>
    {/if}
    
    <style>
        span {
            position: fixed;
            top: 0;
            z-index: 2000;
            padding: 20px;
            width: 100%;
            text-align: center;
            color: #fff;
            background-color: #E74C3C;
            font-weight: bold;
            font-size: 16px;
            display: block;
        }
    </style>
    